// components/chat-thread-header.js — Thread header bar
// ═══════════════════════════════════════════════════════════
// Shown when a session has a title OR when incognito is active.
// Renders: incognito badge | editable title | artifact panel toggle |
//          ContentActionMenu | leave-incognito button.

import IncognitoBadge from './incognito-badge';
import ContentActionMenu from './content-action-menu';

export default function ChatThreadHeader({
  sessionTitle,
  isIncognito,
  editingTitle,
  titleDraft,
  setEditingTitle,
  setTitleDraft,
  onRenameSubmit,
  showArtifactPanel,
  onToggleArtifactPanel,
  artifactIconHover,
  setArtifactIconHover,
  currentSessionId,
  messages,
  userId,
  supabase,
  onLeaveIncognito,
}) {
  if (!sessionTitle && !isIncognito) return null;

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '8px 20px', borderBottom: '0.5px solid #1e1e2a',
      background: '#07070a', flexShrink: 0,
    }}>
      {/* Left: incognito badge OR editable title */}
      {!sessionTitle && isIncognito ? (
        <IncognitoBadge variant="full" color="#7a9e82" />
      ) : (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {isIncognito && <IncognitoBadge variant="icon" color="#444" />}
          {editingTitle ? (
            <input
              autoFocus
              value={titleDraft}
              onChange={e => setTitleDraft(e.target.value)}
              onBlur={onRenameSubmit}
              onKeyDown={e => {
                if (e.key === 'Enter') onRenameSubmit();
                if (e.key === 'Escape') setEditingTitle(false);
              }}
              style={{
                background: 'none',
                border: 'none',
                borderBottom: '1px solid #2a2a2a',
                color: '#888',
                fontSize: 13,
                fontFamily: 'Georgia, serif',
                outline: 'none',
                width: 200,
                padding: '0 2px',
              }}
            />
          ) : (
            <>
              <span
                onClick={() => { setTitleDraft(sessionTitle || ''); setEditingTitle(true); }}
                style={{ color: '#666', fontSize: 13, fontFamily: 'Georgia, serif', cursor: 'pointer' }}
              >
                {sessionTitle || (isIncognito ? 'Nothing stored · private session' : '')}
              </span>
              <svg width="11" height="11" viewBox="0 0 12 12" fill="none"
                onClick={() => { setTitleDraft(sessionTitle || ''); setEditingTitle(true); }}
                style={{ cursor: 'pointer' }}
              >
                <path d="M2 4l4 4 4-4" stroke="#333" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </>
          )}
        </div>
      )}

      {/* Right: artifact toggle + content action menu + leave button */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
        <div
          onClick={onToggleArtifactPanel}
          onMouseEnter={() => setArtifactIconHover(true)}
          onMouseLeave={() => setArtifactIconHover(false)}
          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
            stroke={showArtifactPanel ? '#c8a96e' : artifactIconHover ? '#7a9e82' : '#888'}
            strokeWidth="1.3"
          >
            <rect x="2" y="2" width="12" height="12" rx="2" />
            <path d="M10 2v12" />
          </svg>
        </div>
        <ContentActionMenu
          context="thread"
          contentId={currentSessionId}
          contentType="session"
          messages={messages}
          userId={userId}
          supabase={supabase}
          sessionId={currentSessionId}
        />
        {isIncognito && (
          <div
            onClick={() => {
              if (window.confirm('Leave incognito? All messages will be permanently deleted.')) {
                onLeaveIncognito?.();
              }
            }}
            style={{
              border: '1px solid #333', borderRadius: 6,
              color: '#555', fontSize: 11, fontFamily: 'Georgia, serif',
              padding: '3px 10px', cursor: 'pointer',
              transition: 'color 0.15s',
            }}
            onMouseEnter={e => { e.currentTarget.style.color = '#c46050'; e.currentTarget.style.borderColor = '#c46050'; }}
            onMouseLeave={e => { e.currentTarget.style.color = '#555'; e.currentTarget.style.borderColor = '#333'; }}
          >
            leave
          </div>
        )}
      </div>
    </div>
  );
}
